import { t } from "i18next";
import { postForgotpwd, postResetPassword } from "../../../helpers/fakebackend_helper";
import {
  userForgetPassword as userForgetPasswordAction,
  userForgetPasswordSuccess,
  userForgetPasswordError,
  userPerformResetPassword as userPerformResetPasswordAction,
  userPerformResetPasswordSuccess,
  userPerformResetPasswordError,
  clearErrorMessage
} from "./reducer";


export const userForgetPassword = (user) => async (dispatch) => {
  try {
    dispatch(userForgetPasswordAction());
    const response = await postForgotpwd(user);

    const data = await response.data;

    if (data) {
      dispatch(userForgetPasswordSuccess(t("Password reset link sent successfully!")));
    }
  } catch (forgetError) {
      dispatch(userForgetPasswordError(forgetError))
  }
}

export const userPerformResetPassword = (data) => async (dispatch) => {
  dispatch(userPerformResetPasswordAction());
  try {
    const response = await postResetPassword(data); 
    
    if (response) {
      const successMessage = response.message || t("Your password has been reset successfully");
      dispatch(userPerformResetPasswordSuccess(successMessage));
    } else {
      const errorMessage = response ?  t("Failed to reset password. Please try again.") : "";
      dispatch(userPerformResetPasswordError(errorMessage));
    }
  } catch (resetError) {
    dispatch(userPerformResetPasswordError(resetError));
  }
}

export { clearErrorMessage };